import PageTitle from "@component/PageTitle";
import useIntRouteParam from "@hooks/useIntRouteParam";
import { RootState } from "@redux/rootReducer";
import { fetchVendorDetail, updateVendor } from "@redux/vendorSlice";
import { message, Tabs, Tag } from "antd";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { StaffPermission, usePermission } from "@hooks/usePermission";
import { useAppDispatch } from "src/store";
import { TabWithButtonWrapper, TabWrapper } from "src/styles/common";
import MarginManagement from "./MarginManagement";
import SalesRecord from "./SalesRecord";
import VendorContacts from "./VendorContacts";
import VendorSource from "./VendorSource";
import { EDITABLE_BASIC_STATUSES, EditStatus, tagMap } from "./constant";
import VendorDetails from "./VendorDetails";
import { UpdateVendorPayload } from "./interface";

const { TabPane } = Tabs;

export default function VendorInfoPage() {
  const vendorId = useIntRouteParam("vendorId", true);
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode") || EditStatus.VIEW; // 'view' | 'basic' | 'others'
  const { vendorDetail } = useSelector((state: RootState) => state.vendorSlice);

  const { applicationStatus, sourceId } = vendorDetail || {};
  // 主管及財務不能送出申請
  const cantEditAnything = usePermission([
    StaffPermission.VENDOR_MANAGER_APPROVAL,
    StaffPermission.VENDOR_FINANCE_APPROVAL,
  ])?.some((p) => p);

  const tagInfo = applicationStatus ? tagMap[applicationStatus] : null;
  const TagIcon = tagInfo?.icon;

  const isViewMode = mode === EditStatus.VIEW;
  // 只有在特定狀態下且 mode 為 BASIC 時才允許編輯基本資訊
  const canEditBasic =
    mode === EditStatus.BASIC && EDITABLE_BASIC_STATUSES.includes(applicationStatus || 0) && !cantEditAnything;

  const handleFinish = async (values: UpdateVendorPayload) => {
    if (!vendorId || !canEditBasic) return;
    try {
      await dispatch(updateVendor({ id: vendorId, payload: values })).unwrap();
      message.success("更新成功");
      dispatch(fetchVendorDetail(vendorId));
    } catch {
      // 錯誤由 CoreAPI interceptor 統一處理
    }
  };
  useEffect(() => {
    if (vendorId) dispatch(fetchVendorDetail(vendorId));
  }, [dispatch, vendorId]);

  if (!vendorDetail) return null;
  return (
    <TabWrapper>
      <PageTitle title={`廠商資訊 - ${vendorDetail.name}`} />
      {tagInfo && (
        <TabWithButtonWrapper>
          <Tag icon={TagIcon && <TagIcon />} color={tagInfo.color}>
            {`${tagInfo.text} ${vendorDetail?.rejectReason ? ` : ${vendorDetail?.rejectReason}` : ""}`}
          </Tag>
        </TabWithButtonWrapper>
      )}
      <Tabs defaultActiveKey="1" type="card" size="small">
        <TabPane tab="廠商基本資料" key="1">
          <VendorDetails readOnly={isViewMode || !canEditBasic} onFinish={handleFinish} showSubmit={canEditBasic} />
        </TabPane>
        {/* sourceId表示有曾經完成過審核 */}
        {sourceId && (
          <>
            <TabPane tab="聯絡資訊" key="2">
              <VendorContacts />
            </TabPane>

            <TabPane tab="廠商貨源" key="3">
              <VendorSource source={[]} />
            </TabPane>

            <TabPane tab="保證金管理" key="4">
              <MarginManagement />
            </TabPane>

            <TabPane tab="銷售紀錄" key="5">
              <SalesRecord />
            </TabPane>
          </>
        )}
      </Tabs>
    </TabWrapper>
  );
}
